/*
 * 背景スクロール禁止
 * 本当ならbody-scroll-lock(https://github.com/willmcpo/body-scroll-lock)を利用したいが、うまく行かなかったため独自で実装している。
 */
let current_scrollY; // モーダル表示時の背景の位置

// 背景の位置を固定
function disableBodyScroll() {
  current_scrollY = document.scrollingElement.scrollTop;
  document.body.style.cssText = `position: fixed; top: ${-1 * current_scrollY}px;`;
};

// 背景の位置固定を解除
function enableBodyScroll() {
  document.body.style.cssText = `position: ; top: ;`;
  document.documentElement.scrollTop = current_scrollY;
  document.body.scrollTop = current_scrollY;
};

export { disableBodyScroll, enableBodyScroll };